import type { ParsedParty } from "@/types/api";

function normalize(value: string | null | undefined): string | null {
  if (!value) return null;
  const collapsed = value.replace(/\s+/g, " ").trim();
  return collapsed || null;
}

function line(label: string, value: string | null | undefined): string | null {
  const v = normalize(value);
  return v ? `${label}: ${v}` : null;
}

export function formatPartyForCopy(party: ParsedParty): string {
  const parts: (string | null)[] = [];
  if (party.kind === "individual") {
    parts.push(line("Фамилия", party.last_name));
    parts.push(line("Имя", party.first_name));
    parts.push(line("Отчество", party.middle_name));
    parts.push(line("ИНН", party.inn));
  } else {
    parts.push(line("Наименование", party.name));
    parts.push(line("ИНН", party.inn));
    parts.push(line("КПП", party.kpp));
  }
  parts.push(line("Адрес", party.address_text));
  if (party.kind === "foreign") {
    parts.push(line("Код страны", party.country_code));
  }
  return parts.filter((p): p is string => p !== null).join("\n");
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to textarea fallback
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
